import { render, staticRenderFns } from "./operateTable.vue?vue&type=template&id=6510e8e0"
import script from "./operateTable.vue?vue&type=script&lang=js"
export * from "./operateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports